import { render, staticRenderFns } from "./AcoesArquivoCell.vue?vue&type=template&id=d926eca4&scoped=true"
import script from "./AcoesArquivoCell.vue?vue&type=script&lang=js"
export * from "./AcoesArquivoCell.vue?vue&type=script&lang=js"
import style0 from "./AcoesArquivoCell.vue?vue&type=style&index=0&id=d926eca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d926eca4",
  null
  
)

export default component.exports